import ubBanzai from 'ub/control/banzai-features';

export default {
  load: (mainPageId) => {
    if (ubBanzai.features.isSandboxEnabled()) {
      return 'https://preview.unbounce.com/template.json';
    } else {
      return `/variants/${ mainPageId }/edit.json`;
    }
  },

  save: (webappVariantsResource, mainPageId) =>
    `/${ webappVariantsResource }/${ mainPageId }/save.xml`,

  saveAsNewVariant: mainPageId =>
    `/variants/${ mainPageId }/save_as_new_variant.xml`,

  saveAsTemplate: (webappTemplatesResource, companyId) =>
    `/${ companyId }/${ webappTemplatesResource }.xml`,

  savesList: mainPageId =>
    `/variants/${ mainPageId }/variant_saves_list`,

  savedData: (mainPageId, pomPath) =>
    `/variants/${ mainPageId }/saved_variant_data?pomDataPath=${ encodeURIComponent(pomPath) }`,

  preview: (webappPagesResource, companyId, pageUUID, mainPageId, breakpointName) =>
    `/${ companyId }/${ webappPagesResource }/${ pageUUID }/preview?variant_id=${ mainPageId }#${ breakpointName }`,

  publish: (webappPagesResource, companyId, pageUUID) =>
    `/${ companyId }/${ webappPagesResource }/${ pageUUID }/publish`,

  info: (pollerHostname, webappPagesResource, companyId, pageUUID) =>
    `${ pollerHostname ? '//' + pollerHostname : '' }/${ companyId }/${ webappPagesResource }/${ pageUUID }/info.json`,

  overview: (webappPagesResource, companyId, pageUUID) =>
    `/${ companyId }/${ webappPagesResource }/${ pageUUID }`,

  reportError: pageId =>
    `/variants/${ pageId }/error`,

  assetsByCompanyId: companyId => {
    if (ubBanzai.features.isSandboxEnabled()) {
      return 'https://s3.amazonaws.com/shipit-sandbox-me/images.json';
    } else {
      return `/${ companyId }/assets`;
    }
  },

  imageAssetsByCompanyId: companyId =>
    `/${ companyId }/assets/images`,

  assetById: assetId =>
    `/assets/${ assetId }`,

  deleteAssets: companyId =>
    `/${ companyId }/assets/trash`,

  copyAssetsFromAnotherCompany: companyId =>
    `/${ companyId }/assets/copy_from_another_company`,

  userAccessToken: clientId =>
    `/users/token?context=${clientId}&type=jwt`
};



// WEBPACK FOOTER //
// ./src/config/endpoints.js